// Real-world lat/lng coordinates for every job, territory, and rotating job
// across all 4 eras of KILLING OVER WATER

// Map center + zoom per era
export const ERA_MAP_CONFIG = {
  1: { center: [40.6650, -73.8850], zoom: 13, label: 'East New York, Brooklyn' },
  2: { center: [40.6550, -73.9400], zoom: 11, label: 'Full Brooklyn + Jersey' },
  3: { center: [38.5000, -98.0000], zoom: 4, label: 'Coast to Coast — NYC to LA' },
  4: { center: [38.5000, -98.0000], zoom: 4, label: 'The Empire — Full United States' },
};

// ============================================
// ERA 1 — THE FOUNDATION (East New York)
// ============================================
const ERA1_JOBS = {
  e1j1: [40.6670, -73.8855],  // Run Numbers for Tio
  e1j2: [40.6655, -73.8812],  // Move Product on the D Train
  e1j3: [40.6698, -73.8883],  // Loot During the Blackout
  e1j4: [40.6685, -73.8925],  // Steal Heroin for Antwan
  e1j5: [40.6640, -73.8897],  // Hold Down the Corner
  e1j6: [40.6720, -73.8950],  // Run Surveillance on Ski Crew
  e1j7: [40.6862, -73.9440],  // Survive the Bed-Stuy Chase
  e1j8: [40.8310, -73.9350],  // The Polo Grounds Meeting (Harlem)
};

const ERA1_TERRITORIES = {
  e1t1:  [40.6650, -73.8878],  // Pennsylvania Avenue Corner
  e1t2:  [40.6730, -73.8922],  // Pitkin Avenue Block
  e1t3:  [40.6655, -73.8812],  // The D Train Route
  e1t4:  [40.6673, -73.8858],  // Tio's Building
  e1t5:  [40.6752, -74.0082],  // The Docks (Red Hook)
  e1t6:  [40.5740, -73.9790],  // Coney Island Strip
  e1t7:  [40.6638, -73.8840],  // The Pawn Shop
  e1t8:  [40.6660, -73.8800],  // The Electronics Store
  e1t9:  [40.8314, -73.9352],  // The Polo Grounds Connect
  e1t10: [40.6942, -73.9213],  // Bushwick Warehouse (Papo's)
  e1t11: [40.6578, -73.9005],  // Livonia Avenue Corner
  e1t12: [40.6637, -73.9015],  // Sutter Avenue Stash
  e1t13: [40.6558, -73.8848],  // Rockaway Blvd Block
  e1t14: [40.6860, -73.9770],  // Atlantic Avenue Corridor
  e1t15: [40.6870, -73.9751],  // Fulton Street Market
  e1t16: [40.6632, -73.8892],  // The Bodega Network
  e1t17: [40.6625, -73.8915],  // Van Siclen Avenue
  e1t18: [40.6832, -73.8794],  // Cypress Hills Block
  e1t19: [40.6590, -73.8822],  // The East New York Hub (BOSS)
  e1t20: [40.6574, -73.8304],  // Howard Beach Connect
  e1t21: [40.6243, -73.8893],  // Canarsie Pier Stash
  // EXPANDED
  e1t22: [40.6590, -73.9150],  // Brownsville Projects
  e1t23: [40.6431, -73.9390],  // East Flatbush Corner
  e1t24: [40.6275, -73.9320],  // Flatlands Stash House
  e1t25: [40.6480, -73.8680],  // Spring Creek Block
  e1t26: [40.6175, -73.8575],  // Jamaica Bay Dock
  e1t27: [40.6862, -73.8450],  // Ozone Park Strip
  e1t28: [40.6862, -73.9442],  // Bed-Stuy Corner Store
  e1t29: [40.6694, -73.9422],  // Crown Heights Alley
  e1t30: [40.6560, -73.9680],  // Prospect Park South
};

// ============================================
// ERA 2 — THE RISE (Full Brooklyn)
// ============================================
const ERA2_JOBS = {
  e2j1:  [40.8175, -73.8870],  // Recruit Goonie at Spofford (Bronx)
  e2j2:  [40.6690, -73.9410],  // Recruit Dino (Crown Heights)
  e2j3:  [40.6598, -73.9158],  // Recruit Manny (Brownsville)
  e2j4:  [40.6722, -73.8955],  // Hit the Butcher Shop (Ski Crew)
  e2j5:  [40.6750, -74.0090],  // Run the $25K Heroin Heist (Red Hook)
  e2j6:  [40.7290, -73.9965],  // Perfect the Cook — NYU Chemist
  e2j7:  [40.6548, -73.8955],  // Absorb the 8-Ball Crew
  e2j8:  [40.6908, -73.9372],  // Form Pact with Black Israelites
  e2j9:  [40.7308, -73.9904],  // Pack Webster Hall
  e2j10: [40.6540, -73.8955],  // Absorb Linden Boulevard Kings
};

const ERA2_TERRITORIES = {
  e2t1:  [40.6325, -73.9580],  // Flatbush Avenue
  e2t2:  [40.6590, -73.9150],  // Brownsville Corners
  e2t3:  [40.6694, -73.9422],  // Crown Heights Block
  e2t4:  [40.6872, -73.9418],  // Bedford-Stuyvesant Hub
  e2t5:  [40.6660, -73.9202],  // The Crack Cook Shop
  e2t6:  [40.6755, -73.9102],  // 8-Ball Crew Territory North
  e2t7:  [40.6598, -73.9055],  // 8-Ball Crew Territory South
  e2t8:  [40.6680, -73.9000],  // 8-Ball Crew Territory East
  e2t9:  [40.6910, -73.9370],  // Black Israelites Zone
  e2t10: [40.6540, -73.8955],  // Linden Boulevard
  e2t11: [40.8175, -73.8870],  // Spofford Connections (Bronx)
  e2t12: [40.6775, -74.0088],  // Red Hook Docks
  e2t13: [40.7308, -73.9904],  // Webster Hall Influence (Manhattan)
  e2t14: [40.6342, -73.9942],  // Borough Park Corner
  e2t15: [40.6431, -73.9390],  // East Flatbush Avenue
  e2t16: [40.6602, -73.9800],  // Prospect Park West
  e2t17: [40.6400, -73.8950],  // Canarsie Crew Territory
  e2t18: [40.6950, -73.9210],  // Bushwick Warehouse
  e2t19: [40.6600, -73.9490],  // Nostrand Avenue Block
  e2t20: [40.6510, -73.9305],  // Utica Avenue Strip
  e2t21: [40.6050, -73.9630],  // Kings Highway Connect
  e2t22: [40.5840, -73.9440],  // Sheepshead Bay Dock
  e2t23: [40.6335, -74.0295],  // Bay Ridge Front
  e2t24: [40.6650, -73.8872],  // The CMD Headquarters (BOSS)
  e2t25: [40.5730, -73.9810],  // Coney Island Boardwalk
  e2t26: [40.7138, -73.9722],  // Williamsburg Bridge Block
  e2t27: [40.7033, -73.9883],  // DUMBO Warehouse
  // EXPANDED — Full Brooklyn + Early Jersey
  e2t28: [40.6468, -74.0108],  // Sunset Park Docks
  e2t29: [40.6700, -73.9800],  // Park Slope Front
  e2t30: [40.6068, -73.9952],  // Bensonhurst Italian Block
  e2t31: [40.5778, -73.9600],  // Brighton Beach Russian Corner
  e2t32: [40.7258, -73.9522],  // Greenpoint Avenue
  e2t33: [40.7100, -73.9600],  // Williamsburg South Side
  e2t34: [40.7357, -74.1553],  // Newark Ironbound
  e2t35: [40.7488, -74.0586],  // Jersey City Heights
  e2t36: [40.6665, -74.1107],  // Bayonne Waterfront
  e2t37: [40.6639, -74.2107],  // Elizabeth Port
  e2t38: [40.7647, -74.2318],  // East Orange Block
};

// ============================================
// ERA 3 — THE PEAK (All 5 Boroughs + NJ)
// ============================================
const ERA3_JOBS = {
  e3j1:  [40.7580, -73.9855],  // Meet Claude Devoe (Manhattan)
  e3j2:  [40.6325, -73.9580],  // Open Electronics Store Empire (Brooklyn)
  e3j3:  [40.7357, -74.1724],  // Jordan's Jersey Expansion — Newark
  e3j4:  [40.3573, -74.6672],  // The Princeton Crisis
  e3j5:  [40.7060, -73.9230],  // Hit the Morelli Stash Deli (Bushwick)
  e3j6:  [40.6860, -73.9420],  // Survive Maurice's Retaliation (Brownstone)
  e3j7:  [40.7120, -73.9540],  // Kill Ronald Morelli (Williamsburg)
  e3j8:  [40.7608, -73.9800],  // Broker Gustav's Russian Alliance (Midtown)
  e3j9:  [40.5640, -74.1310],  // Expand South — Richmond
  e3j10: [40.7308, -73.9904],  // Connect with Rico — Webster Hall
  e3j11: [40.6450, -73.9600],  // Secure Paolo's Peruvian Connect
  e3j12: [40.8200, -73.9150],  // Avenge Goonie — Demon's Bronx War
  e3j13: [40.6950, -73.9350],  // The Friday Night Hit — Red Vans
  e3j14: [40.8095, -73.9445],  // Lead Final Strike on Fuego's Lenox Ave
};

const ERA3_TERRITORIES = {
  e3t1:  [40.6325, -73.9580],  // Electronics Store (Brooklyn)
  e3t2:  [40.7282, -73.7949],  // Electronics Store (Queens)
  e3t3:  [40.5795, -74.1502],  // Electronics Store (Staten Island)
  e3t4:  [40.7428, -73.8200],  // Queens Distribution Hub
  e3t5:  [40.7357, -74.1724],  // Newark Jersey Connect
  e3t6:  [40.6920, -73.9850],  // The Laundromat (Claude's Front)
  e3t7:  [40.7060, -73.9230],  // The Morelli Stash House
  e3t8:  [40.6870, -73.9440],  // Anton's Brownstone (Rebuilt)
  e3t9:  [40.6450, -73.9600],  // Paolo's Pipeline
  e3t10: [40.5640, -74.1310],  // Richmond Base (Big Sam's)
  e3t11: [36.8529, -75.9780],  // Virginia Beach Strip
  e3t12: [40.8065, -73.9132],  // La Esquina Caliente (Bronx)
  e3t13: [40.7308, -73.9904],  // Webster Hall VIP
  e3t14: [40.6890, -73.9780],  // PAW Distribution Hub
  e3t15: [40.8200, -73.9150],  // Bronx Distribution (Demon's Turf)
  e3t16: [40.7580, -73.9855],  // Manhattan Midtown Connect
  e3t17: [40.8095, -73.9445],  // DDN Lenox Ave Corridor
  e3t18: [40.7645, -73.9735],  // Gustav's Russian Quarter
  e3t19: [40.5795, -74.1502],  // Staten Island Port
  e3t20: [40.7178, -74.0431],  // Jersey City Pipeline
  e3t21: [40.8250, -73.9390],  // Fuego's Counting House
  e3t22: [40.8096, -73.9459],  // Harlem 125th Street
  e3t23: [40.8530, -73.9342],  // Washington Heights North
  e3t24: [40.8617, -73.8974],  // Fordham Road Block
  e3t25: [40.8094, -73.8803],  // Hunts Point Market
  e3t26: [40.7720, -73.9177],  // Astoria Queens Block
  e3t27: [40.7029, -73.8017],  // Jamaica Avenue
  e3t28: [40.7433, -73.9543],  // Long Island City Warehouse
  e3t29: [40.6335, -74.0295],  // Bay Ridge Waterfront
  e3t30: [40.6650, -73.8870],  // CMD War Room (BOSS)
  e3t31: [40.6413, -73.7781],  // JFK Airport Pipeline
  e3t32: [39.3643, -74.4229],  // Atlantic City Casino Link
  e3t33: [39.9526, -75.1652],  // Philadelphia Pipeline
  e3t34: [38.9072, -77.0369],  // DC Connect (Diego's)
  // EXPANDED — Tri-State + VA + CT + PA
  e3t35: [40.7357, -74.1724],  // Newark Penn Station
  e3t36: [40.6665, -74.1107],  // Bayonne Port Authority
  e3t37: [40.7440, -74.0324],  // Hoboken Waterfront
  e3t38: [40.9168, -74.1718],  // Paterson Silk City
  e3t39: [40.8568, -74.1285],  // Passaic Distribution
  e3t40: [40.2171, -74.7429],  // Trenton State Connect
  e3t41: [40.4862, -74.4518],  // New Brunswick Hub
  e3t42: [41.1792, -73.1894],  // Bridgeport CT Block
  e3t43: [41.7658, -72.6734],  // Hartford CT Pipeline
  e3t44: [41.3083, -72.9279],  // New Haven CT Strip
  e3t45: [41.0534, -73.5387],  // Stamford CT Front
  e3t46: [37.5407, -77.4360],  // Richmond VA Hub
  e3t47: [36.8508, -76.2859],  // Norfolk VA Docks
  e3t48: [39.2904, -76.6122],  // Baltimore Pipeline
  e3t49: [40.9312, -73.8987],  // Yonkers Block
  e3t50: [41.0340, -73.7629],  // White Plains Front
  e3t51: [40.9126, -73.8371],  // Mount Vernon Corner
  e3t52: [40.9115, -73.7824],  // New Rochelle Strip
  // LA / CALIFORNIA
  e3t53: [34.1010, -118.3260],  // Hollywood Hills Front
  e3t54: [34.0736, -118.4004],  // Beverly Hills Strip
  e3t55: [33.9617, -118.3531],  // Inglewood Block
  e3t56: [33.8958, -118.2201],  // Compton Hub
  e3t57: [33.9925, -118.3300],  // Crenshaw Boulevard
  e3t58: [34.0087, -118.3581],  // Baldwin Hills Estates
  e3t59: [33.9932, -118.3432],  // Leimert Park Corner
  e3t60: [34.0259, -118.7798],  // Malibu Beach Front
  e3t61: [34.0824, -118.4406],  // Bel Air Mansion Row
  e3t62: [34.0148, -118.3754],  // Ladera Heights
  e3t63: [33.8847, -118.4109],  // The Dunes (Manhattan Beach)
  e3t64: [34.1368, -118.6607],  // Calabasas Compound
  // NEBRASKA / TEXAS / ATLANTA
  e3t65: [41.2565, -95.9345],  // Omaha Pipeline Hub
  e3t66: [40.8136, -96.7026],  // Lincoln Distribution
  e3t67: [29.7604, -95.3698],  // Houston Ship Channel
  e3t68: [32.7767, -96.7970],  // Dallas Deep Ellum
  e3t69: [29.4241, -98.4936],  // San Antonio Riverwalk
  e3t70: [30.2672, -97.7431],  // Austin South Congress
  e3t71: [33.7537, -84.4142],  // Atlanta Bankhead
  e3t72: [33.7183, -84.3458],  // Atlanta Zone 6
  e3t73: [33.8388, -84.3627],  // Atlanta Buckhead
  e3t74: [33.6534, -84.4494],  // College Park ATL
  e3t75: [31.7619, -106.4850],  // El Paso Border Connect
  e3t76: [32.7555, -97.3308],  // Fort Worth Stockyards
};

// ============================================
// ERA 4 — THE CONSEQUENCES (Prison + Waterfront)
// ============================================
const ERA4_JOBS = {
  e4j1:  [41.1540, -73.7860],  // Run the Commissary (Sing Sing area)
  e4j2:  [41.1545, -73.7855],  // Smuggle a Phone
  e4j3:  [41.1548, -73.7850],  // Form Alliance with Latin Kings
  e4j4:  [41.1535, -73.7862],  // Send Coded Letters to Demon
  e4j5:  [41.1542, -73.7858],  // The Twenty Year Plan
  e4j6:  [40.6750, -74.0082],  // Recruit Juny (Red Hook)
  e4j7:  [40.6468, -74.0108],  // Activate Rosa's Intel (Sunset Park)
  e4j8:  [40.6920, -73.9850],  // Digital Laundering Setup
  e4j9:  [40.7645, -73.9735],  // Turn Gustav
  e4j10: [40.7060, -73.9880],  // Pressure Jacob Hal
  e4j11: [40.7158, -73.9970],  // Negotiate with Chuck Wong (Chinatown)
  e4j12: [40.6775, -74.0090],  // Confront Tito at the Docks
  e4j13: [40.8375, -73.8685],  // Intercept Rodriguez's Ledger
  e4j14: [40.8380, -73.8680],  // Take Down Comm. Rodriguez
  e4j15: [40.6750, -74.0080],  // Expose the $80K Trail — Juny's Proof
  e4j16: [40.7128, -73.9680],  // Final Strike: Vincent's Casino Night
};

const ERA4_TERRITORIES = {
  // Prison blocks (clustered near Ossining/Sing Sing)
  e4t1:  [41.1540, -73.7860],  // Block A — General Population
  e4t2:  [41.1548, -73.7852],  // Block B — South Wing
  e4t3:  [41.1555, -73.7845],  // The Yard
  e4t4:  [41.1533, -73.7868],  // Commissary
  e4t5:  [41.1528, -73.7875],  // Library / Law Section
  e4t6:  [41.1560, -73.7838],  // Chapel Wing
  e4t7:  [41.1545, -73.7842],  // Infirmary Wing
  // Waterfront blocks
  e4t8:  [40.6650, -73.8870],  // Brooklyn CMD HQ (Rebuilt)
  e4t9:  [40.6750, -74.0082],  // Navy Tech Block (Juny's Front)
  e4t10: [40.6590, -73.9150],  // Brownsville Corridor
  e4t11: [40.6468, -74.0108],  // Sunset Park (Rosa's Turf)
  e4t12: [40.6775, -74.0090],  // Red Hook Docks
  e4t13: [40.7580, -73.9855],  // Midtown Manhattan Office
  e4t14: [40.7158, -73.9970],  // Chinatown (Chuck Wong's)
  e4t15: [40.8095, -73.9445],  // Lenox Ave (Former DDN)
  e4t16: [40.8200, -73.9150],  // Bronx Distribution Hub
  e4t17: [40.8148, -73.9218],  // Demon's Territory (South Bronx)
  e4t18: [40.7282, -73.7949],  // Queens Electronics Hub
  e4t19: [40.5795, -74.1502],  // Staten Island Port
  e4t20: [40.7178, -74.0431],  // Jersey City Pipeline
  e4t21: [40.6960, -73.9900],  // The Waterfront Promenade
  e4t22: [40.7357, -74.1724],  // Newark Connect (Jordan's)
  e4t23: [40.8375, -73.8685],  // Comm. Rodriguez's Precinct
  e4t24: [40.7029, -73.8017],  // Jamaica Ave Block
  e4t25: [40.8178, -73.9198],  // South Bronx Block
  e4t26: [40.7075, -74.0113],  // Meilin's Financial District
  e4t27: [40.6755, -74.0075],  // Tazz's Navy Tech Annex
  e4t28: [40.6431, -73.9390],  // Flatbush Digital Hub
  e4t29: [40.6694, -73.9422],  // Crown Heights Crypto Laundry
  e4t30: [40.6862, -73.9442],  // Bed-Stuy Dispensary Front
  e4t31: [40.8188, -73.9352],  // Harlem River Drive Block
  e4t32: [40.7130, -73.9680],  // East River Pier
  e4t33: [40.5740, -73.9790],  // Coney Island Casino Project
  e4t34: [40.6860, -73.9770],  // Atlantic Terminal
  e4t35: [40.6916, -73.9857],  // Downtown Brooklyn Office Tower
  e4t36: [40.7128, -73.9680],  // Vincent's Casino (BOSS)
  e4t37: [40.7736, -73.8728],  // LaGuardia Airport Connect
  e4t38: [40.7060, -74.0090],  // Wall Street Shell Office
  e4t39: [40.6884, -74.0163],  // Governor's Island Vault
  e4t40: [41.0718, -71.9545],  // Montauk Retreat (Endgame)
  // EXPANDED — Full East Coast Modern Empire
  e4t41: [40.7357, -74.1724],  // Newark Digital Hub
  e4t42: [40.6665, -74.1107],  // Bayonne Port Operations
  e4t43: [40.7440, -74.0324],  // Hoboken Tech Incubator
  e4t44: [40.9168, -74.1718],  // Paterson Distribution Center
  e4t45: [40.6639, -74.2107],  // Elizabeth Seaport
  e4t46: [40.2171, -74.7429],  // Trenton State Pipeline
  e4t47: [39.9826, -75.1352],  // Philadelphia North Block
  e4t48: [41.1792, -73.1894],  // Bridgeport CT Operations
  e4t49: [41.7658, -72.6734],  // Hartford CT Network
  e4t50: [37.5407, -77.4360],  // Richmond VA Digital
  e4t51: [36.8529, -75.9780],  // Virginia Beach Strip
  e4t52: [39.2904, -76.6122],  // Baltimore Inner Harbor
  e4t53: [38.9072, -77.0369],  // DC Georgetown Connect
  e4t54: [40.9312, -73.8987],  // Yonkers Command Post
  e4t55: [41.0340, -73.7629],  // White Plains Office
  e4t56: [40.9132, -72.6462],  // Long Island Hamptons
  e4t57: [39.3643, -74.4229],  // Atlantic City Casino
  e4t58: [42.3601, -71.0589],  // Boston Seaport
  // LA / CALIFORNIA — MODERN EMPIRE
  e4t59: [34.1010, -118.3260],  // Hollywood Hills Penthouse
  e4t60: [34.0736, -118.4004],  // Beverly Hills Rodeo Drive
  e4t61: [34.0824, -118.4406],  // Bel Air Estate
  e4t62: [34.0259, -118.7798],  // Malibu Colony
  e4t63: [33.9617, -118.3531],  // Inglewood Crypto Hub
  e4t64: [33.8958, -118.2201],  // Compton Digital Block
  e4t65: [33.9925, -118.3300],  // Crenshaw Tech Corridor
  e4t66: [34.0087, -118.3581],  // Baldwin Hills Command
  e4t67: [33.9932, -118.3432],  // Leimert Park Network
  e4t68: [34.0148, -118.3754],  // Ladera Heights Office
  e4t69: [33.8847, -118.4109],  // The Dunes (Manhattan Beach)
  e4t70: [34.1368, -118.6607],  // Calabasas Compound
  e4t71: [34.0195, -118.4912],  // Santa Monica Pier Front
  e4t72: [34.0407, -118.2468],  // Downtown LA Arts District
  e4t73: [33.9850, -118.4695],  // Venice Beach Boardwalk
  // NEBRASKA / TEXAS / ATLANTA — MODERN
  e4t74: [41.2565, -95.9345],  // Omaha Crypto Farm
  e4t75: [40.8136, -96.7026],  // Lincoln Tech Hub
  e4t76: [29.7604, -95.3698],  // Houston Energy Corridor
  e4t77: [32.7512, -96.7856],  // Dallas Bishop Arts
  e4t78: [29.4588, -98.4700],  // San Antonio Medical Center
  e4t79: [30.2672, -97.7431],  // Austin Tech Corridor
  e4t80: [33.7490, -84.4125],  // Atlanta Trap Museum Block
  e4t81: [33.6407, -84.4277],  // Atlanta Airport Connect
  e4t82: [33.8461, -84.3734],  // Atlanta Peachtree Tower
  e4t83: [33.6534, -84.4494],  // College Park Studios
  e4t84: [31.7619, -106.4850],  // El Paso Digital Border
  e4t85: [32.7555, -97.3308],  // Fort Worth Alliance
};

// ============================================
// ROTATING JOBS — Street Hustles
// ============================================
const ROTATING_ERA1 = {
  r1c01: [40.6650, -73.8878],  // Collect Debts on Pennsylvania Ave
  r1c02: [40.6632, -73.8892],  // Sell Loosies Outside the Bodega
  r1c03: [40.6860, -73.9770],  // Boost a Car on Atlantic Ave
  r1c04: [40.6643, -73.8847],  // Run a Dice Game in the Alley
  r1c05: [40.6660, -73.8800],  // Guard the Stash House
  r1c06: [40.6325, -73.9580],  // Deliver a Package to Flatbush
  r1c07: [40.6720, -73.8952],  // Tag Rival Crew Walls
  r1c08: [40.6752, -74.0082],  // Pick Up Supply from the Docks
  r1c09: [40.6638, -73.8840],  // Shake Down the Pawn Shop Owner
  r1c10: [40.6660, -73.8803],  // Fence Stolen Electronics
  r1u01: [40.6670, -73.8855],  // Rob the Numbers Runner
  r1u02: [40.6718, -73.8948],  // Ambush a Ski Crew Pickup
  r1u03: [40.6635, -73.8895],  // Protect a Local Business
  r1u04: [40.6645, -73.8860],  // Drive Getaway for a Crew Heist
  r1u05: [40.6700, -73.8880],  // Intercept a Rival's Drug Shipment
  r1u06: [40.6950, -73.9210],  // Break Into the Abandoned Warehouse
  r1u07: [40.6628, -73.8888],  // Collect Protection from 3 Bodegas
  r1u08: [40.6642, -73.8837],  // Set Up a Floating Poker Game
  r1r01: [40.6655, -73.8812],  // The Subway Hustle — Full D Train
  r1r02: [40.6670, -73.8860],  // Tio's Secret Errand
  r1r03: [40.6722, -73.8955],  // Midnight Raid on Ski Crew
  r1r04: [40.6700, -73.8885],  // The 1977 Blackout — Grand Larceny
  // EXPANDED
  r1c11: [40.6590, -73.9150],  // Run Product to Brownsville
  r1c12: [40.6694, -73.9422],  // Collect from Crown Heights Bodega
  r1c13: [40.6275, -73.9320],  // Scout Flatlands for Stash Sites
  r1c14: [40.6175, -73.8575],  // Hustle at Jamaica Bay Market
  r1c15: [40.6862, -73.8450],  // Make a Run to Ozone Park
  r1u09: [40.6602, -73.9700],  // Hit the Prospect Park Dice Game
  r1u10: [40.7100, -73.9500],  // Move Product Through the L Train
  r1r05: [40.6862, -73.9442],  // The Bed-Stuy All-Nighter
};

const ROTATING_ERA2 = {
  r2c01: [40.6660, -73.9202],  // Cook a Batch at the Lab
  r2c02: [40.6325, -73.9580],  // Collect from Flatbush
  r2c03: [40.6655, -73.9170],  // Re-Up the Corner Boys
  r2c04: [40.6694, -73.9422],  // Scout Crown Heights
  r2c05: [40.6658, -73.9198],  // Run the Count
  r2c06: [40.6540, -73.8955],  // Enforce on Linden Blvd
  r2c07: [40.6590, -73.9150],  // Deliver to Brownsville
  r2c08: [40.6862, -73.9442],  // Manage Dice Game Bed-Stuy
  r2c09: [40.6775, -74.0088],  // Pickup from Red Hook Dock
  r2c10: [40.6750, -73.9102],  // Collect from 8-Ball Crew
  r2u01: [40.6660, -73.9210],  // Test the New Product
  r2u02: [40.6700, -73.9300],  // Hijack a Rival Delivery Truck
  r2u03: [40.6800, -73.9500],  // Launder Cash Through Barbershop
  r2u04: [40.6860, -73.9770],  // Intimidate the Witness Atlantic
  r2u05: [40.7308, -73.9904],  // Supply Webster Hall After-Party
  r2u06: [40.8175, -73.8870],  // Recruit from Spofford Detention
  r2u07: [40.6862, -73.9445],  // Set Up Safe House Bed-Stuy
  r2u08: [40.6950, -73.9210],  // Negotiate Jamaican Connect
  r2r01: [40.7630, -73.8308],  // The $50K Heist — Flushing
  r2r02: [40.8200, -73.9150],  // Goonie's Special Assignment
  r2r03: [40.7058, -73.9963],  // Brooklyn Bridge Standoff
  r2r04: [40.6685, -73.8925],  // Antwan's Lesson — The Chainsaw
  // EXPANDED — Jersey + Wider Brooklyn
  r2c11: [40.6468, -74.0108],  // Run Product to Sunset Park Docks
  r2c12: [40.5778, -73.9600],  // Collect from Brighton Beach
  r2c13: [40.7357, -74.1553],  // Supply the Newark Ironbound
  r2c14: [40.7488, -74.0586],  // Make a Drop in Jersey City
  r2c15: [40.6665, -74.1107],  // Hustle in Bayonne Waterfront
  r2u09: [40.6639, -74.2107],  // Open a Line to Elizabeth Port
  r2u10: [40.6068, -73.9952],  // Shake Down the Bensonhurst Italians
  r2r05: [40.7440, -74.0324],  // The Jersey Turnpike Run
};

const ROTATING_ERA3 = {
  r3c01: [40.6325, -73.9580],  // Run Electronics Store Hustle
  r3c02: [40.7282, -73.7949],  // Collect from Queens Distribution
  r3c03: [40.7357, -74.1724],  // Supply the Newark Pipeline
  r3c04: [40.6920, -73.9850],  // Manage Claude's Laundry Cycle
  r3c05: [40.8200, -73.9150],  // Enforce on the Bronx Blocks
  r3c06: [40.8095, -73.9445],  // Collect Rent from Lenox Ave
  r3c07: [36.8529, -75.9780],  // Run Virginia Beach Supply Line
  r3c08: [40.6450, -73.9600],  // Pick Up from Paolo's Contact
  r3c09: [40.7308, -73.9904],  // Host VIP Event at the Club
  r3c10: [40.5795, -74.1502],  // Negotiate with Staten Island Port
  r3u01: [40.6920, -73.9870],  // Move $500K Through Car Dealership
  r3u02: [40.8065, -73.9132],  // Broker Truce with Los Diablos
  r3u03: [40.6870, -73.9440],  // Set Up Real Estate Shell Company
  r3u04: [40.7580, -73.9855],  // Intercept Federal Wire Tap
  r3u05: [40.7310, -73.9908],  // Supply Rico's Rap Label Event
  r3u06: [40.7178, -74.0431],  // Expand Distribution to Jersey City
  r3r01: [40.7060, -73.9230],  // The Morelli Vault Heist
  r3r02: [40.8205, -73.9155],  // Demon's Revenge — Bronx Blitz
  r3r03: [40.7580, -73.9860],  // The Five-Borough Summit
  r3r04: [40.6450, -73.9605],  // Paolo's Final Shipment
  // EXPANDED — NJ + CT + VA + PA
  r3c11: [40.7357, -74.1724],  // Run the Newark Pipeline
  r3c12: [40.6665, -74.1107],  // Supply Bayonne Port Workers
  r3c13: [40.7440, -74.0324],  // Collect from Hoboken Front
  r3c14: [40.9168, -74.1718],  // Manage the Paterson Hub
  r3c15: [41.1792, -73.1894],  // Run Supply to Bridgeport CT
  r3c16: [41.7658, -72.6734],  // Collect from Hartford CT
  r3c17: [37.5407, -77.4360],  // Supply the Richmond VA Hub
  r3c18: [36.8508, -76.2859],  // Norfolk Dock Pickup
  r3u07: [39.2904, -76.6122],  // Open the Baltimore Pipeline
  r3u08: [40.2171, -74.7429],  // Establish Trenton State Connect
  r3u09: [39.9526, -75.1652],  // Philadelphia North Expansion
  r3u10: [40.9312, -73.8987],  // Yonkers Back Door Route
  r3r05: [40.7128, -73.9680],  // The I-95 Corridor Run
  r3r06: [39.3643, -74.4229],  // The Atlantic City Score
  // LA HUSTLES
  r3c19: [33.9617, -118.3531],  // Supply the Inglewood Connect
  r3c20: [33.9925, -118.3300],  // Collect from Crenshaw Boulevard
  r3c21: [33.8958, -118.2201],  // Run Product to Compton
  r3u11: [34.0736, -118.4004],  // Beverly Hills Laundering Op
  r3u12: [34.1368, -118.6607],  // Calabasas Real Estate Flip
  r3r07: [34.0087, -118.3581],  // The Coast-to-Coast Run
  // NEBRASKA / TEXAS / ATLANTA HUSTLES
  r3c22: [41.2565, -95.9345],  // Run Product to Omaha
  r3c23: [29.7604, -95.3698],  // Supply the Houston Ship Channel
  r3c24: [32.7767, -96.7970],  // Collect from Dallas Deep Ellum
  r3c25: [33.7537, -84.4142],  // Atlanta Bankhead Run
  r3c26: [33.7183, -84.3458],  // Supply Atlanta Zone 6
  r3u13: [31.7619, -106.4850],  // El Paso Border Pipeline
  r3u14: [33.8388, -84.3627],  // Atlanta Buckhead Laundering
  r3r08: [33.7490, -84.4125],  // The Southern Pipeline
};

const ROTATING_ERA4 = {
  r4c01: [41.1540, -73.7860],  // Run the Prison Yard Hustle
  r4c02: [41.1545, -73.7855],  // Coordinate Drops via Encrypted Phone
  r4c03: [40.6920, -73.9850],  // Manage Digital Laundering Cycle
  r4c04: [40.6960, -73.9900],  // Enforce on Waterfront Blocks
  r4c05: [40.6650, -73.8870],  // Collect from Brooklyn Operations
  r4c06: [40.6468, -74.0108],  // Run Intel Through Rosa's Network
  r4c07: [40.8200, -73.9150],  // Supply Bronx Through Demon
  r4c08: [40.7158, -73.9970],  // Negotiate with Red Serpents
  r4c09: [40.7128, -73.9680],  // Flip a Vincent Loyalist
  r4c10: [40.7130, -73.9685],  // Run the Casino Night Operation
  r4u01: [40.7060, -73.9880],  // Hack Vincent's Financial Records
  r4u02: [40.8375, -73.8685],  // Set Up Sting on Rodriguez's Cops
  r4u03: [40.7075, -74.0113],  // Broker Meilin Zhang's Financial Deal
  r4u04: [40.7580, -73.9855],  // Intercept Federal Task Force
  r4u05: [40.7128, -73.9682],  // Disrupt Vincent's Supply Chain
  r4u06: [40.6755, -74.0075],  // Tazz's Navy Tech Surveillance Op
  r4r01: [40.7130, -73.9680],  // The Waterfront Heist — $10M
  r4r02: [40.8378, -73.8682],  // Rodriguez's Ledger
  r4r03: [40.7300, -73.9500],  // The Final Reckoning — All Boroughs
  r4r04: [40.7128, -73.9680],  // Lena's Choice — Father and Daughter
  // EXPANDED — Full East Coast Modern
  r4c11: [40.7357, -74.1724],  // Manage Newark Digital Hub
  r4c12: [40.6665, -74.1107],  // Run Bayonne Port Operations
  r4c13: [40.7440, -74.0324],  // Collect from Hoboken Tech Front
  r4c14: [40.9168, -74.1718],  // Supply the Paterson Network
  r4c15: [40.6639, -74.2107],  // Manage Elizabeth Seaport
  r4c16: [41.7658, -72.6734],  // Run Product to Hartford CT
  r4c17: [37.5407, -77.4360],  // Collect from Richmond VA
  r4c18: [39.2904, -76.6122],  // Baltimore Inner Harbor Drop
  r4u07: [39.9526, -75.1652],  // Philadelphia Expansion Deal
  r4u08: [38.9072, -77.0369],  // DC Georgetown Laundering
  r4u09: [39.3643, -74.4229],  // Atlantic City Casino Night Op
  r4u10: [42.3601, -71.0589],  // Boston Seaport Connection
  r4r05: [40.7300, -73.9500],  // The Full East Coast Run
  r4r06: [40.6665, -74.1107],  // The Bayonne Heist
  // LA HUSTLES — MODERN ERA
  r4c19: [34.1010, -118.3260],  // Run the Hollywood Hills Circuit
  r4c20: [33.9617, -118.3531],  // Collect from Inglewood Crypto Hub
  r4c21: [33.9925, -118.3300],  // Supply Crenshaw Tech Corridor
  r4c22: [34.0087, -118.3581],  // Manage Baldwin Hills Operations
  r4u11: [34.0736, -118.4004],  // Beverly Hills Art Laundering
  r4u12: [34.0259, -118.7798],  // Malibu Colony Deal
  r4u13: [34.1368, -118.6607],  // Calabasas Compound Expansion
  r4r07: [34.0407, -118.2468],  // The Bi-Coastal Empire Run
  // NEBRASKA / TEXAS / ATLANTA — MODERN HUSTLES
  r4c23: [41.2565, -95.9345],  // Manage Omaha Crypto Farm
  r4c24: [29.7604, -95.3698],  // Run Houston Energy Corridor Op
  r4c25: [32.7512, -96.7856],  // Collect from Dallas Bishop Arts
  r4c26: [33.7490, -84.4125],  // Atlanta Trap Museum Circuit
  r4c27: [33.6534, -84.4494],  // Supply College Park Studios
  r4u14: [33.6407, -84.4277],  // Atlanta Airport Money Wash
  r4u15: [30.2672, -97.7431],  // Austin Tech Laundering
  r4r08: [33.7537, -84.4142],  // The Full American Pipeline
};

// ============================================
// DARIUS 'STACKS' HENDERSON — LA CONTINUATION
// ============================================
const DARIUS_LOCATIONS = {
  // Story jobs
  dj1:  [33.9425, -118.4081],  // LAX Airport
  dj2:  [34.0522, -118.2437],  // Downtown LA (identity papers)
  dj3:  [33.9925, -118.3300],  // Crenshaw Boulevard scouting
  dj4:  [34.0736, -118.4004],  // Beverly Hills (Persian investors)
  dj5:  [34.1010, -118.3260],  // Hollywood and Vine (V.I.P. location)
  dj6:  [34.1010, -118.3270],  // V.I.P. hiring
  dj7:  [34.1015, -118.3265],  // V.I.P. Grand Opening
  dj8:  [34.0736, -118.4010],  // Beverly Hills (Cyrus)
  dj9:  [34.0740, -118.4008],  // V.I.P. Beverly Hills
  dj10: [34.0259, -118.7798],  // Malibu real estate
  dj11: [34.1368, -118.6607],  // Calabasas compound
  dj12: [34.0522, -118.2440],  // Phone call from Brooklyn
  dj13: [34.0522, -118.2445],  // The detective
  dj14: [34.0736, -118.4015],  // Persian betrayal
  dj15: [34.0522, -118.2450],  // Burn the trail
  dj16: [40.6775, -74.0082],   // Return to the Water (Brooklyn docks)
  // Darius territories
  dt1:  [34.1010, -118.3260],  // V.I.P. Hollywood
  dt2:  [34.0736, -118.4004],  // V.I.P. Beverly Hills
  dt3:  [34.1368, -118.6607],  // Calabasas Compound
  dt4:  [34.0259, -118.7798],  // Malibu Colony House
  dt5:  [33.9925, -118.3300],  // Crenshaw Recording Studio
  dt6:  [33.9617, -118.3531],  // Inglewood Distribution
  dt7:  [33.9850, -118.4695],  // Venice Beach Dispensary
  dt8:  [34.0407, -118.2468],  // Downtown LA Gallery
  dt9:  [34.0195, -118.4912],  // Santa Monica Pier Front
  dt10: [40.6775, -74.0082],   // The Waterfront Casino (Brooklyn)
  // Darius crew
  darius_c1: [34.0736, -118.4004],  // Reza
  darius_c2: [34.1010, -118.3260],  // Marcus
  darius_c3: [34.0740, -118.4010],  // Cyrus
};

// Merge all coordinates into one lookup
export const COORDS = {
  ...ERA1_JOBS, ...ERA1_TERRITORIES,
  ...ERA2_JOBS, ...ERA2_TERRITORIES,
  ...ERA3_JOBS, ...ERA3_TERRITORIES,
  ...ERA4_JOBS, ...ERA4_TERRITORIES,
  ...ROTATING_ERA1, ...ROTATING_ERA2,
  ...ROTATING_ERA3, ...ROTATING_ERA4,
  ...DARIUS_LOCATIONS,
};

// Get coordinates for any ID, with fallback scatter around era center
export const getCoords = (id, era = 1) => {
  if (COORDS[id]) return COORDS[id];
  // Fallback: scatter around era center with deterministic offset from ID hash
  const config = ERA_MAP_CONFIG[era] || ERA_MAP_CONFIG[1];
  let hash = 0;
  for (let i = 0; i < id.length; i++) hash = ((hash << 5) - hash) + id.charCodeAt(i);
  const latOff = ((hash % 100) / 10000) - 0.005;
  const lngOff = (((hash >> 8) % 100) / 10000) - 0.005;
  return [config.center[0] + latOff, config.center[1] + lngOff];
};
